import React from "react";
import Input from "./Input";

/**
 * Shared one-time-code input used by reset-password and MFA screens.
 */
const AuthCodeInput = ({ value, onChange, placeholder = "Verification Code" }) => {
  const handleChange = React.useCallback(
    ({ id, value: nextValue }) => {
      onChange({
        id,
        value: String(nextValue || "").replace(/\D/g, "").slice(0, 6),
      });
    },
    [onChange]
  );

  return (
    <Input
      id="code"
      inputMode="numeric"
      autoComplete="one-time-code"
      onChange={handleChange}
      placeholder={placeholder}
      value={value}
      maxLength={6}
    />
  );
};

export default AuthCodeInput;
